const apiUrl = process.env.REACT_APP_API_URL;
export const GetJutgeActivitatIdProblemaIdTests= async (id_activitat: string, id_problema: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/activitats/${id_activitat}/problemes/${id_problema}/tests`);
        const jsonData = await response.json();
        return jsonData;

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
